import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { authSignUp, appData } from "../../../../core/axios/services";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import "./SignUp.scss";
import quote from "../../../../../src/quote.svg";
import brock from "../../../../../src/Brock_Headshot.jpg";
import { addUser, addUserToken } from "../../../../redux/actions/user";
import {
  getApiErrorMessage,
  setPendingSignupData,
} from "../../../../services/helpers";

// Components
import TextInputLabel from "../../../components/Comon/TextInput/TextInput";
import Logo from "../../../components/Comon/Logo/Logo";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader

const SignUp = ({ showGlobalSnackbar }) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [passwordRepeat, setPasswordRepeat] = useState("");
  const logo = "/assets/logotm.png";
  const [testimonials, setTestimonials] = useState([]);
  const [testimonial, setTestimonial] = useState({});

  useEffect(() => {
    collectAppData().then((data) => {
      setTestimonials([
        {
          name: data.landingData.testimonial_1_name,
          job: data.landingData.testimonial_1_job,
          image: data.landingData.testimonial_1_image,
          text: data.landingData.testimonial_1_text,
        },
        {
          name: data.landingData.testimonial_2_name,
          job: data.landingData.testimonial_2_job,
          image: data.landingData.testimonial_2_image,
          text: data.landingData.testimonial_2_text,
        },
        {
          name: data.landingData.testimonial_3_name,
          job: data.landingData.testimonial_3_job,
          image: data.landingData.testimonial_3_image,
          text: data.landingData.testimonial_3_text,
        },
      ]);
      // setLogo(data.logo);
    });
  }, []);

  useEffect(() => {
    if (testimonials.length === 0) {
      return;
    }

    const randomNumber = Math.floor(Math.random() * testimonials.length);
    setTestimonial(testimonials[randomNumber]);
  }, [testimonials]);

  const collectAppData = async () => {
    return appData().then((res) => res.data.data);
  };

  const [searchParams] = useSearchParams();
  const plainId = searchParams.get("plainId");

  const signUp = async () => {
    let re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!re.test(email)) {
      showGlobalSnackbar(i18n.t("emailFormat"));
      return;
    }

    try {
      return await authSignUp(email, password, passwordRepeat).then((res) => {
        const userId = res?.data?.data?.id || res?.data?.data?.user?.id;

        localStorage.setItem("signUpEmail", email);
        localStorage.setItem("email", email);
        localStorage.setItem("password", password);
        localStorage.setItem("repeat", passwordRepeat);
        localStorage.setItem("userId", userId);
        setPendingSignupData({
          email,
          userId,
          planId: plainId,
        });
        dispatch(addUser(res.data.data));
        dispatch(addUserToken(res.data.data));

        if (plainId) {
          navigate("/otp?planId=" + plainId);
        } else {
          navigate("/otp");
        }
      });
    } catch (error) {
      showGlobalSnackbar(getApiErrorMessage(error, i18n.t("thereWasAnError")));
    }
  };

  return (
    <div className="signUpWrapper">
      <a href="https://chiropracticoutcomes.com/" style={{ cursor: "pointer" }}>
        <Logo className="logo" src={logo} />
      </a>
      <div className="signUpContent">
        <div className="signUpForm">
          <div className="formWrapper">
            <h2>{t("welcomeSignUp")}</h2>
            <TextInputLabel
              type={"email"}
              label={i18n.t("signUpemailAddress")}
              value={email}
              setValue={setEmail}
              placeholder={t("enterYourEmail")}
            />
            <TextInputLabel
              type={"password"}
              label={i18n.t("password")}
              value={password}
              setValue={setPassword}
              placeholder={t("enterYourPassword")}
            />
            <div className="passwordRequire">
              <p>{t("passwordConsistOf")}</p>
              <ul>
                <li>{t("passwordMinimum")}</li>
                <li>{t("upperlLower")}</li>
                <li>{t("passowrdNumbers")}</li>
              </ul>
            </div>
            <div className="passwordRequireMob">
              <p>{t("mobilePasswordMust")}</p>
            </div>
            <TextInputLabel
              type={"password"}
              label={i18n.t("confirmPassword")}
              value={passwordRepeat}
              setValue={setPasswordRepeat}
              placeholder={t("enterYourPasswordConfirm")}
              required
            />
            <div className="privacyTermsLink">
              <p>
                {t("readPolicy")} <a href="http://chiropracticoutcomes.com/privacy">{t("privacypolicy")}</a>{" "}
                {t("and")} <a href="http://chiropracticoutcomes.com/terms">{t("terms")}</a>
              </p>
            </div>

            <div className="privacyTermsLinkMobile">
              <p>
                {t("readPolicy")} <br />
                <a href="http://chiropracticoutcomes.com/privacy">{t("privacypolicy")}</a> {t("and")}{" "}
                <a href="http://chiropracticoutcomes.com/terms">{t("terms")}</a>
              </p>
            </div>
            <div className="buttonSubmit" onClick={signUp}>
              <button>{t("createAccoutBtn")}</button>
            </div>
            <div className="haveAcc">
              <a href="/login">{t("alreadyHave")}</a>
            </div>
          </div>
        </div>
        <div className="signUpTestimonials">
          <h2>{t("customersReview")}</h2>
          <div className="testimonialContent">
            <img className="quote" src={quote} alt="quote" />

            <p>{t("signUpTestimonialDes")}</p>
            <span></span>
            <div className="testimonialName">
              {testimonial?.image ? <img src={brock} alt="brock" /> : null}
              <div>
                <div className={"testimonial-name"}>
                  {t("signUpTestimonialName")}
                </div>
                <div className={"testimonial-job"}>
                  {t("signUpTestimonialJob")}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignUp;
